export default __webpack_public_path__ + "static/media/sd-accommodation.05aec047.png";